import React from 'react';
import { ProductCat } from 'data/e-commerce/products';
import ProductCardCat from 'components/common/ProductCardCat';
import Swiper from 'components/base/Swiper';
import { SwiperSlide } from 'swiper/react';
import { useAppContext } from 'providers/AppProvider';

const EcomRecentProducts = ({ products }: { products: ProductCat[] }) => {
  const {
    config: { theme }
  } = useAppContext();
  return (
    <div
      className={`bg-light rounded-3 p-4 ${theme === 'dark' ? 'bg-dark' : ''}`}
    >
      <div className=" d-flex flex-between-center mb-3">
        <h3 className="mb-6 mt-2 fs-5">Recent Products</h3>
      </div>
      <Swiper
        slidesPerView={5}
        spaceBetween={16}
        navigationPosition={{ top: '25%' }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          450: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 16
          },
          1540: {
            slidesPerView: 5,
            spaceBetween: 16
          }
        }}
      >
        {products.map(product => (
          <SwiperSlide key={product._id}>
            <ProductCardCat product={product} setProduct={() => {}} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default EcomRecentProducts;
